<template>
  <div class="secondary-nav">

    <div class="gap-10 d-flex justify-content-between align-items-center w-100 h-100">
      <div class="h-100">

        <div class="h-100 draw-settings" v-if="activeStage.preview === false && activeStage.mainJob !== null">
<draw-settings></draw-settings>
        </div>

      </div>
      <div class="d-flex gap-10px h-100">
        <div class="magic-tools-container">
        <div @click="zoomFit" v-if="activeStage.mainJob !== null" class="magic-tool">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                <path stroke-miterlimit="1" d="M15 12a3 3 0 1 0-6 0a3 3 0 0 0 6 0"/>
                <path
                    d="M9.4 21c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6m18 0c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21m0-18c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4M9.4 3c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 6.04 3 7.16 3 9.4"/>
              </g>
            </svg>
          <span v-if="resultPage.isFullRes === true">Center</span>
        </div>

        <div @click="zoomIn" v-if="activeStage.mainJob !== null" class="magic-tool">
            <i class="far fa-search-plus"></i>
          <span v-if="resultPage.isFullRes === true">Zoom In</span>
        </div>

        <div @click="zoomOut" v-if="activeStage.mainJob !== null" class="magic-tool">
            <i class="far fa-search-minus"></i>
          <span v-if="resultPage.isFullRes === true">Zoom Out</span>
        </div>
      </div>
      </div>

    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import CanvasManager from "../../manager/CanvasManager";
import DrawSettings from "../Elements/DrawSettings.vue";

export default {
  name: "InpaintNav",
  props: {},
  components: {DrawSettings},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    zoomFit() {
      CanvasManager.zoomFitAllObjects(this.activeStage);
    },
    zoomIn() {
      CanvasManager.zoomIn(this.activeStage);
    },
    zoomOut() {
      CanvasManager.zoomOut(this.activeStage);
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.draw-settings {
  border-right: 1px solid #595959;
  padding-right: 20px;
}
.magic-tools-container {
  display: flex;
  align-items:center;
  .magic-tool {
    display: flex;
    align-items:center;
    gap: 10px;
    border-left: 1px solid #595959;
    height: 100%;
    padding: 0 20px;
    cursor: pointer;
  }
}
.nav-btn {
  border: 1px solid #ccc;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
}

.secondary-nav {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  background: white;
  border-bottom: 1px solid #CBCBCB;
  padding: 0 20px;
  min-height: 50px;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}
</style>
